export default __webpack_public_path__ + "static/media/chairs001.0899b703.jpeg";